<template>
  <router-view />
</template>

<script>
export default {
  name: 'PurchaseOrders'
};
</script>

<style lang="scss" scoped></style>
